'use strict';

exports.__esModule = true;

var _logAppender = require('./log.appender.factory');

var _logAppender2 = _interopRequireDefault(_logAppender);

var _log = require('./log.configuration');

var _log2 = _interopRequireDefault(_log);

var _logModel = require('./log.model.factory');

var _logModel2 = _interopRequireDefault(_logModel);

var _logFilter = require('./log.filter.definitions');

var _logFilter2 = _interopRequireDefault(_logFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var elkLogLib = function elkLogLib() {
    _classCallCheck(this, elkLogLib);
};

elkLogLib.logAppenderFactory = _logAppender2.default;
elkLogLib.logConfiguration = _log2.default;
elkLogLib.logModelFactory = _logModel2.default;
elkLogLib.logFilterDefinitions = _logFilter2.default;
exports.default = elkLogLib;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/elk/index.js
// module id = 867
// module chunks = 0